
import { SiteUtilities } from './utils';

const init = () => {
  /* @desc - Returns the cards to be shown after filtering
    $elements - array of cards to be filtered
    key - Category name
    selectedItem - Item currently chosen for filtering
    checkbox - Identifier for differentiating checkbox and dropdown
  */
  const filterSelection = ($elements, key, selectedItem, checkbox = false) => {
    return $elements.filter((index, item) => {
      const filterItems = $(item).data(`filter-${checkbox ? 'checkbox' : 'dropdown'}-${SiteUtilities.convertToHTMLAttribute(key)}`) || null;
      if (filterItems) {
        // Split string to array -> filter out null elements -> trim extra spaces in individual items
        return filterItems.split(',')
          .filter(item => item != null && item !== '')
          .map(item => item.trim())
          .some(elem => {
          // Drop down is single select unlike checkbox where multiple selection is allowed
            return checkbox ? selectedItem.includes(elem) : selectedItem === elem;
          });
      }
      return false;
    });
  };

  const handleFilter = function (e) {
    const noResultFor = $('.custom-filter-section[data-no-result-found]').attr('data-no-result-found');
    let showResultFor = $('.custom-filter-section[data-show-result-for]').attr('data-show-result-for');
    const $filterContainer = $(`[data-filter="filter-results-container"]`);
    let $elements = $('[data-filter="filter-results-container"] a.card-item, [data-filter="filter-results-container"] div.card-box');
    let filterCriteriaLabel = '';

    const dropDownLabels = [];
    $('[data-filter-dropdown]').each(function () {
      const $current = $(this);
      const selectedValueLabel = $current.find('input').val();

      if (selectedValueLabel !== '') {
        const dropDownLabel = $current.attr('data-filter-dropdown');
        $elements = filterSelection($elements, dropDownLabel, selectedValueLabel);
        dropDownLabels.push(`<em><b>${dropDownLabel}:</b> ${selectedValueLabel}</em>`);
      }
    });

    const checkBoxLabels = [];
    $('[data-filter-checkbox]').each(function () {
      const checkBoxFilters = [];
      const checkBoxLabel = [];
      const $parent = $(this);
      const key = $parent.attr('data-filter-checkbox');
      let checkedCount = 0;

      $parent.find('input').each(function () {
        const $current = $(this);
        if ($current.is(':checked')) {
          checkedCount++;
          checkBoxLabel.push($current.parent().text().trim());
          checkBoxFilters.push($current.val());
        }
      });

      if (checkedCount > 0) {
        $elements = filterSelection($elements, key, checkBoxFilters, true);
        checkBoxLabels.push(`<em><b>${key}:</b> ${checkBoxLabel.join(' or ')}</em>`);
      }
    });
    filterCriteriaLabel = (dropDownLabels.concat(checkBoxLabels)).join('<br/>');

    if (filterCriteriaLabel === '') {
      $('.podcast-results-summary').html('').hide();
      $(`[data-filter="filter-results-container"]`).find('a.card-item, div.card-box').show();
      return;
    }

    if ($elements.length === 0) {
      showResultFor = noResultFor;
    }

    showResultFor += '<br/>' + filterCriteriaLabel;
    $('.podcast-results-summary').html(showResultFor).show();
    $filterContainer.find('a.card-item, div.card-box').hide();
    $elements.show();
  };

  $('.general-filter-form').on('change', function (e) {
    handleFilter(e);
  });

  $('.podcast-filter-section .partner-field-dropdown').off('click').on('click', function () {
    const $wrapper = $(this).closest('.podcast-filter-section');
    $wrapper.toggleClass('active');
    if ($wrapper.hasClass('active')) toggleTabIndexFormSection(0);
    else toggleTabIndexFormSection(-1);
  });

  $('.clear-filter-button').on('click', function (e) {
    $('.general-filter-form .dropdown-select-input').attr('value', '');
    $('input[type="checkbox"]').each(function () {
      $(this).prop('checked', false);
    });
    handleFilter(e);
  });

  $('.podcast-filter-section .partner-field-dropdown').off('keydown').on('keydown', function (event) {
    const $this = $(this);
    const code = event.which || event.keyCode || 0;
    if ([13, 32].includes(code)) {
      event.preventDefault();
      $this.trigger('click');
    }
  });

  const $toggleFormWrapper = $('.partner-expandable.filters-expandable');
  const toggleTabIndexFormSection = (value) => {
    if ($(window).innerWidth() >= 960 || !$toggleFormWrapper.length) return;
    $toggleFormWrapper.find('[tabindex]').each(function () {
      this.setAttribute('tabindex', value);
    });
  };

  toggleTabIndexFormSection(-1);
};

export default {
  init
};
